import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import VerticalPrimeTable from "../../common/DataTable/verticalPrimeTable";
import LogsVerticalPrimeTable from "../../common/DataTable/logsVerticalPrimeTable";
import Tag from 'apollo-react/components/Tag';

export default function LogDetails({ persona }) {
  const [log, setLog] = useState();
  const [actor, setActor] = useState();
  const [target, setTarget] = useState();
  const [fieldChangesData, setfieldChangesData] = useState([])
  const { id } = useParams();
  useEffect(() => {
    const fetchLog = async () => {
      await axiosInstance
        .get(`/api/logs/log/${id}`)
        .then((response) => {
          setLog(response.data.log);
          
          try {
            setfieldChangesData([
            {
              Field:"Field Changes",
              Old_Value: "Old Value",
              New_Value: "New Value",
            },
            ...Object.entries(JSON.parse(response.data.log?.field_changes || "{}")).map(
              ([field, changes]) => ({
              Field: field,
              Old_Value: (typeof changes?.old === 'string' && changes?.old?.includes(',')) ? 
                changes.old.split(",").map((val)=>{
                return <Tag className="log-tag" label={val} variant={"neutral"} ></Tag>
                }) : changes?.old ?? "N/A",
              New_Value: (typeof changes?.new === 'string' && changes?.new?.includes(',')) ? 
                changes.new.split(",").map((val)=>{
                return <Tag className="log-tag" label={val} variant={"neutral"} ></Tag>
                }) : changes?.new ?? "N/A",
              })
            ),
            ])
          } catch (error) {
            setfieldChangesData([]);
          }
          
          setActor(response.data.actor);
          setTarget(response.data.target);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    fetchLog();
  }, [id, persona]);
  return (
    <div className="container mt-4">
      <div className="card">
        {/* <div className="card-header bg-primary text-white">Log Details</div> */}
        {log && (
          <div className="card-body">
            <div>
              <VerticalPrimeTable
                data={{
                  id: log.id,
                  Action: log.action,
                  Actor_name: actor?.username,
                  Actor_email: actor?.email,
                  Created_at: log.createdAt,
                  Entity_id: log.entity_id,
                  Name: log.entity_name,
                  Resource: log.resource,
                  ...(target
                    ? {
                        Target_name: target?.username,
                        Target_email: target?.email,
                      }
                    : {}),

                  Updated_at: log.updatedAt,
                  Version: log.version,
                }}
                actions={[]}
              />
            </div>

            {log.action === "update" && (
				<div>
					<LogsVerticalPrimeTable
					data={fieldChangesData}
					columns={[
						{ field: "Field", header: "Field Name" },
						{ field: "Old_Value", header: "Old Value" },
						{ field: "New_Value", header: "New Value" },
					]}
					/>
					{/* <LogsVerticalPrimeTable/> usage */}
				</div>
			)}

          </div>
        )}
      </div>
    </div>
  );
}
